<template>
  <textarea :class="{invalid: errors.has(name)}" :placeholder="placeholder" v-validate.immediate="validate" class="form-control" type="text" v-model="model" :name="name" :id="'id_' + name +'_'+ (Date.now())"></textarea>
</template>

<script>
import {IMaskDirective} from "vue-imask";

export default {
  name: "BaseTextarea",
  directives: {
    imask: IMaskDirective
  },
  inject: ['$validator'],
  props: {
    validate: {
      type: String,
      default: 'required'
    },
    value: {
      type: [String, Number, Object],
      description: 'Input value'
    },
    name: {
      type: String,
      required: true,
      default: 'base-input'
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      model: this.value
    }
  },
  watch: {
    model: {
      handler: function(val) {
        this.$emit('input', val)
      },
      deep: true,
      immediate: true
    },
    value: {
      handler: function(val) {
        this.model = val
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>